import React, { useEffect, useState } from "react";
import useHttp from '../../../../hook/use-http';
import Chart from 'react-apexcharts'
import stats from 'wink-statistics';
import NoData from '../NoData';
import ChartLoader from '../ChartLoader';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import { BsZoomIn } from "react-icons/bs";
import WaterMark from "../../DashboardMain/WaterMark";

function RealWorldBox({ apiend, gloablfilter }) {
  const [chartdata, setChartData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();

  const appyData = (data) => {
    const res_result = data;
    if (res_result.length != 0) {
      let temp_result = res_result;
      let res_result_final = [{
        type: 'boxPlot',
        data: []
      }]
      let y_data_set = [];
      temp_result.map(x => {
        if (x.fields.hasOwnProperty('Range')) {
          y_data_set.push(parseFloat((x.fields.Range[0]).toFixed(2)));
        }
      })
      y_data_set = y_data_set.sort(function (a, b) { return a - b });
      let boxplot = stats.data.boxplot;
      let data_set = boxplot(y_data_set);
      res_result_final[0].data.push({ x: "Ace Ev", y: [data_set.min.toFixed(2), data_set.q1.toFixed(2), data_set.median.toFixed(2), data_set.q3.toFixed(2), data_set.max.toFixed(2)] })
      setChartData((prestate) => res_result_final);
      window.dispatchEvent(new Event('resize'));
    } else {
      setChartData((prestate) => []);
      window.dispatchEvent(new Event('resize'));
    }
  }

  const options = {
    tooltip: {
      fixed: {
        enabled: true,
        position: 'topLeft',
        offsetX: -20,
        offsetY: -100,
      },
    },
    chart: {
      toolbar: {
        show: false
      },
      type: 'boxPlot',
      height: 350
    },
    yaxis: {
      show: true,
      title: {
        text: "Range",
        style: {
          color: undefined,
          fontSize: '9px',
          fontStyle: "italic",
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 100,
        }
      },
      labels: {
        formatter: function (val) {
          return val.toFixed(0);
        }
      }
    },
    grid: {
      yaxis: {
        lines: {
          show: false,
        }
      }
    },
    plotOptions: {
      boxPlot: {
        colors: {
          upper: '#FFFFFF',
          lower: '#FFFFFF'
        }
      }
    }
  };

  const options_popup = {
    tooltip: {
      fixed: {
        enabled: true,
        position: 'topLeft',
        offsetX: -20,
        offsetY: -60,
      },
    },
    chart: {
      toolbar: {
        show: false
      },
      type: 'boxPlot',
      height: 350
    },
    yaxis: {
      show: true,
      title: {
        text: "Range",
        style: {
          color: undefined,
          fontSize: '9px',
          fontStyle: "italic",
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 100,
        }
      },
      labels: {
        formatter: function (val) {
          return val.toFixed(0);
        }
      }
    },
    grid: {
      yaxis: {
        lines: {
          show: false,
        }
      }
    },
    plotOptions: {
      boxPlot: {
        colors: {
          upper: '#FFFFFF',
          lower: '#FFFFFF'
        }
      }
    }
  };

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + apiend, body: { filterdata: gloablfilter } }, appyData)
  }, [gloablfilter])

  return (
    <>
      <div className="modal fade" id="realworlsecond" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">Real World Range Distribution</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body" style={{ height: "400px" }}>
              <WaterMark />
              {(isLoading) ? <ChartLoader /> : ((chartdata.length == 0) ? <NoData /> : <Chart options={options_popup} series={chartdata} type="boxPlot" height={300} />)}
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-12">
        <div className="titlebg p-2">Real World Range Distribution</div>
      </div>
      <strong style={{ float: "right", cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#realworlsecond"} > <BsZoomIn /> </strong>

      <div className="col-md-6">
        <div className=" p-2">
          <div className="v-title">
            <div className="chartHGT">
              <WaterMark />
              {(isLoading) ? <ChartLoader /> : ((chartdata.length == 0) ? <NoData /> : <Chart options={options} series={chartdata} type="boxPlot" height={220} />)}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RealWorldBox;